import { render, staticRenderFns } from "./AccountSearchExtension.vue?vue&type=template&id=5fe061ee&"
import script from "./AccountSearchExtension.vue?vue&type=script&lang=js&"
export * from "./AccountSearchExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports